<button  
    role="button"
    tabindex="0"
    [class]="classes" 
    (click)="onClick()"
    [attr.aria-label]="label"
    [disabled]="disabled"
>
    @if (label.length) {
        <span class="uppercase">
            {{ label }}
        </span>
    }

    @else if (type === 'pill') {
        <i class="h-4 w-4">
            <ng-content select="icon"/>
        </i>
    }

    @else {
        <ng-content/>
    }

    
</button>